import "./styles.scss";

import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";

import { timeDisplayFormat } from "../../utils/utils";
import Up from "../../assets/images/icons/icon_cs_up.png";
import Down from "../../assets/images/icons/icon_cs_down.png";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import IconAvatar from "../../assets/images/profile/img_placeholder.svg";

function TicketMessages() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { ticket, ticketMessages } = useSelector((state) => state.customerServiceReducer);

  const [isVisibleExtra, setIsVisibleExtra] = useState(false);

  const filterMessages = (messages) => {
    return messages.filter((_, index) => {
      if (ticket.status === "cancelled") {
        if (index > messages.length - 7 && index !== messages.length - 1) {
          return true;
        } else return false;
      }
      if (index > messages.length - 6) {
        return true;
      }
    });
  };

  let filtredMessages = [];
  filtredMessages = !isVisibleExtra ? filterMessages(ticketMessages) : ticketMessages;

  return (
    <div className="notes">
      {filtredMessages.length > 0 && (
        <Fragment>
          <h2>{t("HISTORY")}</h2>
          {ticketMessages.length > 5 && (
            <div className="extras">
              {!isVisibleExtra ? (
                <button onClick={() => setIsVisibleExtra(!isVisibleExtra)}>
                  Show more messages ({ticketMessages.length})<img src={Down} />
                </button>
              ) : (
                <button onClick={() => setIsVisibleExtra(!isVisibleExtra)}>
                  Show less messages <img src={Up} />
                </button>
              )}
            </div>
          )}
          <hr />
          {filtredMessages.map((ticketMessage) => {
            const userTimeZone = moment(ticketMessage.updatedAt).tz(user.timezone);
            return (
              <div
                key={ticketMessage.id}
                className={`infos ${ticketMessage.creatorUser.id === user.id ? "owner" : ""}`}
              >
                <div className="avatar">
                  <img src={ticketMessage.creatorUser.picture || IconAvatar} alt="" />
                </div>
                <div className="boxWhite">
                  <div className="textBox">
                    <div className="infoPerfil">
                      <div className="itemInfo">{decryptIfEncrypted(ticketMessage?.creatorUser?.name)}</div>
                      <div className="itemInfo">
                        <span>{t(`CARD_LIST_CUSTOM_SERVICE.${ticketMessage?.creatorUser?.role}`)}</span>
                      </div>
                      <div className="itemInfo">
                        {userTimeZone.format(t("DATE_FORMAT")) +
                          " • " +
                          t("WEEK_" + userTimeZone.format("dddd").toUpperCase()) +
                          " • " +
                          userTimeZone.format(timeDisplayFormat(user?.timeDisplayFormat))}
                      </div>
                    </div>
                    <div className="message">
                      <p>{ticketMessage.message}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <hr />
        </Fragment>
      )}
    </div>
  );
}

export default TicketMessages;
